import request from '@/utils/request'

export function getAreaList () {
  return request({
    url: '/area/list/',
    method: 'get'
  })
}

export function getActivityCalendar (query) {
  return request({
    url: '/activity/calendar/',
    method: 'get',
    params: query
  })
}

export function getActivityRecommend () {
  return request({
    url: '/activity/recommend/',
    method: 'get'
  })
}

export function getActivityList (query) {
  return request({
    url: '/activity/list/',
    method: 'get',
    params: query
  })
}

export function getActivityDetail(id) {
  return request({
    url: '/activity/' + id + '/detail/',
    method: 'get'
  })
}

export function getActivityMember(id, query) {
  return request({
    url: '/activity/' + id + '/member/',
    method: 'get',
    params: query
  })
}

export function getActivityEvaluation(id, query) {
  return request({
    url: '/activity/' + id + '/evaluation/',
    method: 'get',
    params: query
  })
}
